// import Vue from 'vue'
// import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
//
// Vue.use(Router)

export default new VueRouter({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component:() => import('@/components/index'),
      // meta:{
      //   requireAuth:true,
      // }
    },
    {
      path: '/echartZ',
      name: 'echartZ',
      component:() => import('@/components/echartZ'),
      // meta:{
      //   requireAuth:true,
      // }
    },
    {
      path: '/login',
      name: 'login',
      component:() => import('@/components/login'),
    },
    {
      path: '/act',
      name: 'act',
      component:() => import('@/components/act'),
      meta:{
        requireAuth:true,
      }
    },
    {
      path: '/member',
      name: 'member',
      component:() => import('@/components/member'),
      meta:{
        requireAuth:true,
      }
    },
    {
      path:'/manage',
      name:'manage',
      component:() => import('@/components/manage'),
      meta:{
        requireAuth:true,
      }
    },
    {
      path:'/exList',
      name:'exList',
      component:() => import('@/components/exList'),
      meta:{
        requireAuth:true,
      }
    },
    {
      path:'/exApply',
      name:'exApply',
      component:() => import('@/components/exApply'),
      meta:{
        requireAuth:true,
      }
    },
    {
      path:'/exAudit',
      name:'exAudit',
      component:() => import('@/components/exAudit'),
      meta:{
        requireAuth:true,
      }
    },
    {
      path:'/record',
      name:'record',
      component:() => import('@/components/record'),
      // meta:{
      //   requireAuth:true,
      // }
    },
    {
      path:'/addSupport',
      name:'addSupport',
      component:() => import('@/components/addSupport'),
      meta:{
        requireAuth:true,
      }
    },
    {
      path:'/addAct',
      name:'addAct',
      component:() => import('@/components/addAct'),
      meta:{
        requireAuth:true,
      }
    },
    {
      path:'/sign',
      name:'sign',
      component:() => import('@/components/sign')
    },
    {
      path:'/interview',
      name:'interview',
      component:() => import('@/components/interview')
    },
    {
      path:'/company',
      name:'company',
      component:() => import('@/components/company')
    },
    {
      path:'/ranking',
      name:'ranking',
      component:() => import('@/components/ranking'),
      // meta:{
      //   requireAuth:true,
      // }
    },
    {
      path:'/picker',
      name:'picker',
      component:() => import('@/components/picker'),
    },
    {
      path:'/int',
      name:'int',
      component:() => import('@/components/int'),
    },
    {
      path:'/intAudit',
      name:'intAudit',
      component:() => import('@/components/intAudit'),
      meta:{
        requireAuth:true,
      }
    },
    {
      path:'/addInt',
      name:'addInt',
      component:() => import('@/components/addInt'),
      meta:{
        requireAuth:true,
      }
    },
    {
      path:'/fillImg',
      name:'fillImg',
      component:() => import('@/components/fillImg'),
      meta:{
        requireAuth:true,
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js